import { useFeatureFlag } from '~/hooks/account';

function useVisitorReport() {
  const { enabled: reportEnabled, loading: loadingReport } = useFeatureFlag(
    'visitor_report_in_platform',
  );

  const { enabled: internal, loading: loadingInternal } = useFeatureFlag(
    'x_clearbit_internal',
  );

  return {
    enabled: reportEnabled || internal,
    loading: loadingReport || loadingInternal,
  };
}

export default useVisitorReport;
